/**
 * Footer-based cookie notice component for landing page
 * Simple, inline notice in the footer without floating dialog
 */
import i18n from '../../shared/i18n/config.ts';
import { getCookieConsent, setCookieConsent } from '../../shared/utils/cookieConsent.ts';

let footerCookieNoticeInstance = null;

export function initFooterCookieNotice() {
  if (footerCookieNoticeInstance) {
    return footerCookieNoticeInstance;
  }

  const notice = document.getElementById('footerCookieNotice');
  const manageBtn = document.getElementById('footerCookieManage');
  const menu = document.getElementById('footerCookieMenu');
  const disableBtn = document.getElementById('footerCookieDisable');

  if (!notice || !manageBtn || !menu || !disableBtn) {
    return;
  }

  let showMenu = false;

  // Update text when language changes
  const updateText = () => {
    // Text is already in HTML via data-i18n, but we can update if needed
    manageBtn.setAttribute('aria-label', i18n.t('cookieNotice.manage'));
    disableBtn.setAttribute('aria-label', i18n.t('cookieNotice.disable'));
  };

  // Handle manage button click
  manageBtn.addEventListener('click', (e) => {
    e.stopPropagation();
    showMenu = !showMenu;
    if (showMenu) {
      menu.classList.add('open');
    } else {
      menu.classList.remove('open');
    }
  });

  // Handle disable button click
  disableBtn.addEventListener('click', (e) => {
    e.stopPropagation();
    setCookieConsent(false);
    showMenu = false;
    menu.classList.remove('open');
    // Optionally hide the notice after disabling
    notice.style.display = 'none';
  });

  // Close menu when clicking outside
  const clickOutsideHandler = (e) => {
    if (showMenu && !notice.contains(e.target)) {
      showMenu = false;
      menu.classList.remove('open');
    }
  };

  document.addEventListener('mousedown', clickOutsideHandler);

  // Update text on language change
  i18n.on('languageChanged', updateText);
  updateText();

  footerCookieNoticeInstance = {
    destroy: () => {
      document.removeEventListener('mousedown', clickOutsideHandler);
      i18n.off('languageChanged', updateText);
      footerCookieNoticeInstance = null;
    }
  };

  return footerCookieNoticeInstance;
}

